// Plaza Room Configuration

import { Room } from '../config/room-types.js';
import { STANDARD_BOUNDARIES, COMMON_SPAWNS } from '../config/room-constants.js';

export const plazaRoom: Room = {
  name: 'Plaza',
  background: '/media/club-penguin/plaza.png',
  spawn: COMMON_SPAWNS.LEFT_ENTRANCE,
  music: '/media/audio/Northbridge_Southbridge.mp3',

  colliders: [
    ...STANDARD_BOUNDARIES,
    // Plaza-specific obstacles
    { x: 17, y: 17, w: 926, h: 306 },
  ],

  hotspots: [
    {
      id: 'plaza-to-town',
      x: 23,
      y: 285,
      w: 137,
      h: 76,
      action: 'goto',
      target: 'town',
      spawn: { x: 850, y: 400 },
    },

    {
      id: 'plaza-to-cove',
      action: 'goto',
      target: 'cove',
      spawn: { x: 845, y: 319 },
      x: 845,
      y: 319,
      w: 94,
      h: 99,
    },
  ],
};
